import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/ui/Button"
import { NonIdealState } from "@components/ui/NonIdealState"
import { CartItem, useCart } from "@features/ticketing/useCart"
import { useSquadup } from "@features/ticketing/useSquadUp"
import { formatDateTime } from "@utils/date-format"
import { Link } from "eddev/routing"
import { useFlyingCarpet } from "../useFlyingCarpet"

export function CartPanel() {
  const flyingCarpet = useFlyingCarpet()
  const cart = useCart()
  const squadup = useSquadup()

  if (cart.items.length === 0) {
    return (
      <NonIdealState
        icon="cart"
        title="Your cart is empty"
        description="Add items to your cart to see them here."
        actions={
          <>
            <Link href="/browse" as={Button}>
              View Program
            </Link>
          </>
        }
      />
    )
  }

  console.log("Cart", cart)

  return (
    <div className="w-full h-full stack-y-0">
      <div className="stack-y-1 flex-col overflow-auto flex-1">
        {cart.items.map((item, i) => (
          <div key={i}>
            <CartItemDisplay cartItem={item} />
          </div>
        ))}
      </div>
      <div className="p-3 flex-0 flex gap-1">
        <Button className="flex-grow w-full" variant="outline" onClick={() => flyingCarpet.close()}>
          Close Cart
        </Button>
        <Button className="flex-grow w-full" onClick={() => squadup.open({ showCheckout: true })}>
          Checkout
        </Button>
      </div>
    </div>
  )
}

function CartItemDisplay(props: { cartItem: CartItem }) {
  const squadup = useSquadup()
  const item = props.cartItem

  return (
    <div className="stack-y-0 m-2 bg-grey2">
      {/* Event Info */}
      <Link href={item.siteEvent?.uri} className="p-2 type-body-s flex gap-2">
        <div className="w-[18%] flex-none">
          {item.siteEvent?.thumb && <ResponsiveImage {...item.siteEvent?.thumb} />}
        </div>
        <div>
          <span>{item.siteEvent?.title ?? item.event.name}</span>
          <div className="opacity-60">{formatDateTime(item.event.start_at)}</div>
        </div>
        <div>
          <Button
            size="icon"
            icon="add"
            onClick={() => {
              squadup.openEvent(item.event.id)
            }}
          />
        </div>
      </Link>

      {/* Tickets */}
      {item.tickets.map((ticket, j) => (
        <div className="px-2 py-1 border-t border-black/10" key={j}>
          <div className="flex type-body-xs gap-2 text-black" key={j}>
            <div className="flex-1">{ticket.priceTier.name}</div>
            <div>{ticket.quantity} Tickets</div>
            <div>{ticket.priceTier.price || "$0"}</div>
          </div>
          <div className="text-muted">Seat A4, A8</div>
        </div>
      ))}
    </div>
  )
}
